// extracted by mini-css-extract-plugin
export default {"tab__wrapper":"Portfolio_tab__wrapper__btd-k","list__wrapper":"Portfolio_list__wrapper__zByje"};